document.addEventListener("turbolinks:load", function () {
  const DOMAIN = $('#pl_domain').val();
  const isSpecialURL = window.location.href.includes(`${DOMAIN}/ugc_report`) || 
                      window.location.href == `${DOMAIN}` || 
                      window.location.href == `${DOMAIN}/`;

  // トグルボタンのクリックイベント
  $('#darkmode_toggle').on("change", function() {
    if (isSpecialURL) {
      if ($('html').hasClass('dark')) {
        document.cookie = "dark_mode=disabled"; // Set cookie
      } else {
        document.cookie = "dark_mode=enabled"; // Set cookie
      }
      location.reload();
    } else {
      $('html').toggleClass('dark');

      if ($('html').hasClass('dark')) {
        $('html').attr('data-theme', 'dark');
        document.cookie = "dark_mode=enabled"; // Set cookie
      } else {
        $('html').attr('data-theme', 'light');
        document.cookie = "dark_mode=disabled"; // Set cookie
      }
    }
  });
});